 $('document').ready(function(){
   if($('body').hasClass('template-customers/addresses') || $('body').hasClass('template-page')){
      sessionStorage.setItem("dataRedirect",'');
    }
    var url = sessionStorage.getItem("dataRedirect");
    if(url == 'addresses' && $('body').hasClass('template-customers/account')) window.location.href='/account/addresses';
    if(url){
     show_tab(url);
    }else{
      if($('body').hasClass('template-customers/account')){
      $(`[data-redirect="overview"]`).parent().addClass('active_tab');
       $('.account_overview_main').show();
      $('.account_overview_right').removeClass('loader_view');
      }
    }

    $('body').on('click','.account_overview_left ul li a,.button_main_side',function(e){
      
      e.preventDefault();
      var url_change = $(this).attr('data-redirect');
      if(url_change){
        console.log(url_change);
        sessionStorage.setItem("dataRedirect",url_change);
        if(url_change == 'addresses') window.location.href='/account/addresses';
        if(url_change == 'wishlist') window.location.href='/pages/custom-wishlist';
        if(url_change == 'saveforlater') window.location.href='/pages/save-for-later';
        //console.log($(this).attr(''))
        if($('body').hasClass('template-customers/addresses')) window.location.href=$(this).attr('href');
        if($('body').hasClass('template-customers/order')) window.location.href=$(this).attr('href');
        if($('body').hasClass('template-page')) window.location.href=$(this).attr('href');
        show_tab(url_change); 
      }
     
    })

    function show_tab(tab){
      console.log('tab');
      console.log(tab);
      $('.account_overview_left li').removeClass('active_tab');
      $(`[data-redirect="${tab}"]`).parent().addClass('active_tab');
      $('.main_over').hide();
       // $('.account_overview_right').addClass('loader_view');
      if(tab == 'overview'){
         $('.account_overview_main').show();
      $('.account_overview_right').removeClass('loader_view');
      }else if(tab == 'wishlist'){
      //   $('.account_overview_wishlist').show();
      // $('.account_overview_right').removeClass('loader_view');
      }else if(tab == 'recent'){
        $('.account_overview_recentview').show();
      $('.account_overview_right').removeClass('loader_view');
      }
      else if(tab == 'history'){
        $('.account-overview_history').show();
      $('.account_overview_right').removeClass('loader_view');
      }
      else if(tab == 'reset'){
        $('.account-overview_reset_password').show();
      $('.account_overview_right').removeClass('loader_view');
      }
      else if(tab == 'reward'){
        $('.account-overview_wallet,div#rise-check-balance-theme-app-extension').show();
       
         if($('.check_balence_form').find('#rise-check-balance-theme-app-extension').length  < 1){
const watch_interval = setInterval(function () {
  if($('#rise-check-balance-theme-app-extension').length > 0){
    $('.check_balence_form').html($('#rise-check-balance-theme-app-extension'));
   clearInterval(watch_interval);
  }
}, 1000);
  }
 console.log($('.rise_popup_wallet').find('iframe').length);
         if($('.rise_popup_wallet').find('iframe').length < 1){
        const watch_interval_popup = setInterval(function () {
  if($('.Rise-popup').length > 0){
    $('.rise_popup_wallet').html($('.Rise-popup iframe'));
   clearInterval(watch_interval_popup);
  }
}, 1000);
         }
        

      $('.account_overview_right').removeClass('loader_view');
      }
      
    }
  })